<template>
  <div class="card">
    <div
      class="card-header"
      :class="card.title.toLowerCase().replace(' ', '-')"
      :style="{ backgroundColor: getLoggedInUser.linked_entity.secondary_color }"
    >
      <span>{{ card.title }}</span>
    </div>
    <div class="card-content">
      <div class="icon" :class="card.icon">
        <span class="material-icons icon-32pt">
          {{ card.icon }}
        </span>
      </div>
      <p class="description">{{ card.description }}</p>
      <span
        v-if="card.openModal"
        class="btn btn-dark"
        :style="{ backgroundColor: getLoggedInUser.linked_entity.primary_color, border: 'none' }"
        @click="$emit('open-flashcard-modal', card)"
      >
        {{ card.buttonText }}
      </span>
      <a
        v-else-if="card.buttonEnabled"
        :href="card.route"
        class="btn btn-dark"
        :style="{ backgroundColor: getLoggedInUser.linked_entity.primary_color, border: 'none' }"
        >{{ card.buttonText }}</a
      >
      <span
        v-if="!card.buttonEnabled"
        class="action-button text-muted border"
        :variant="card.buttonEnabled ? 'primary' : ''"
        :class="{ disabled: !card.buttonEnabled }"
      >
        {{ card.buttonText }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CardItem',
  components: {},
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    isMobileScreen() {
      return window.innerWidth < 768;
    },
  },
  methods: {},
};
</script>

<style scoped>
.card {
  min-width: 280px;
  width: 280px;
  margin-right: 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: var(--shadow);
  background-color: var(--white);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: var(--hover-shadow);
}

.card:last-child {
  margin-right: 0;
}

.card-header {
  background-color: var(--primary-color);
  color: white;
  padding: 18px;
  text-align: center;
}

.card-header span {
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin-bottom: 0px;
}

.card-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 220px;
}

.icon {
  margin-bottom: 16px;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
}

.description {
  text-align: center;
  margin-bottom: 24px;
  color: var(--light-text);
  font-size: 14px;
  line-height: 1.5;
  flex-grow: 1;
}

.action-button {
  padding: 5px 10px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
}

.action-button.disabled {
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .card {
    min-width: 250px;
    width: 250px;
  }

  .card-content {
    padding: 20px;
    min-height: 200px;
  }

  .icon {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 480px) {
  .card {
    min-width: 220px;
    width: 220px;
    margin-right: 15px;
  }

  .card-header {
    padding: 12px;
  }

  .card-header h2 {
    font-size: 16px;
  }

  .card-content {
    padding: 16px;
    min-height: 180px;
  }

  .icon {
    width: 40px;
    height: 40px;
    margin-bottom: 12px;
  }

  .description {
    font-size: 13px;
    margin-bottom: 16px;
  }

  .action-button {
    padding: 8px 20px;
    font-size: 13px;
  }
}
</style>
